import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, HomeIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CourseSidebar from '../components/course/CourseSidebar';
import VideoPlayer from '../components/course/VideoPlayer';
import CourseContentTabs from '../components/course/CourseContentTabs';
const CourseDetailPage = () => {
  const navigate = useNavigate();
  const [activeModule, setActiveModule] = useState(3);
  const [activeLesson, setActiveLesson] = useState(1);
  const [activeTab, setActiveTab] = useState('descrizione');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleBack = () => {
    navigate('/');
  };
  return <div className="flex h-screen bg-gray-100" data-id="element-1653">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1654">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1655"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black overflow-hidden" data-id="element-1656">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1657">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1658">
              <span className="sr-only" data-id="element-1659">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1660" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1661">
            <Sidebar activePage="formazione" data-id="element-1662" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1663">
        <Sidebar activePage="formazione" data-id="element-1664" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1665">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1666" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1667">
          <div className="max-w-6xl mx-auto pt-4 md:pt-6" data-id="element-1668">
            {/* Course title and info */}
            <div className="mb-6" data-id="element-1669">
              <h1 className="text-2xl font-semibold text-gray-800" data-id="element-1670">
                Innovazione Sostenibile
              </h1>
              <p className="text-sm text-gray-500" data-id="element-1671">
                Corso completo • 8 moduli • 28 lezioni
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1672">
              {/* Course Sidebar as a widget */}
              <div className="lg:col-span-1" data-id="element-1673">
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1674">
                  <div className="p-4 border-b border-gray-200" data-id="element-1675">
                    <h2 className="text-base font-semibold text-gray-800" data-id="element-1676">
                      Contenuti del corso
                    </h2>
                  </div>
                  <CourseSidebar activeModule={activeModule} activeLesson={activeLesson} onModuleChange={setActiveModule} onLessonChange={setActiveLesson} data-id="element-1677" />
                </div>
              </div>
              {/* Main Content */}
              <div className="lg:col-span-2" data-id="element-1678">
                <VideoPlayer module={activeModule} lesson={activeLesson} data-id="element-1679" />
                <CourseContentTabs activeTab={activeTab} onTabChange={setActiveTab} module={activeModule} lesson={activeLesson} data-id="element-1680" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default CourseDetailPage;